import * as mutationTypes from 'store/mutationTypes'

/**
 * @return {Promise}
 */
export const addTopBarNotification = function ({ commit }, notification) {
  notification.timeout = notification.timeout || 10000

  return commit(mutationTypes.ADD_TOP_BAR_NOTIFICATION, notification)
}

/**
 * @return {Promise}
 */
export const removeTopBarNotification = function ({ commit }) {
  return commit(mutationTypes.REMOVE_TOP_BAR_NOTIFICATION)
}



// WEBPACK FOOTER //
// ./src/store/modules/topBarNotifications/actions.js